import { action } from 'easy-peasy';
import { IActionSetDevices } from '../types';

const setDevices: IActionSetDevices = action((state, payload) => {
  const hasMore = state.pagination.itemsPerPage === payload.length;

  state.items = payload;
  state.pagination.page += 1;
  state.pagination.hasMore = hasMore;
});

export default setDevices;
